import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../../features/snackbar';
import { deleteSubscriber } from '../../../../features/subscriber';

const DIALOG_ID = "deleteSubscriber"
const DIALOG_WIDTH = "sm"

function DeleteSubscriberDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const project = useSelector(state => state.project.single);
    const subscriberId = useSelector((state) => state.dialog[DIALOG_ID])
    const subscribers = useSelector(state => state.subscriber.list || state.subscriber.all);
    const subscriber = subscribers && subscribers.find(el => el.id === subscriberId);

    const subscriberLabel =  Array.isArray(subscriberId) ? "selected" : (subscriber ? subscriber.name : "");
    const show = !!subscriberId;

    const handleSubmit = e => {
        e && e.preventDefault() && e.stopPropagation();
        setLoading(true);
        dispatch(deleteSubscriber({
            project,
            id: subscriberId
        }))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Subscriber deleted"))
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    
    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={handleSubmit}>
            <DialogTitle>
                Delete subscriber
            </DialogTitle>
            <DialogContent dividers={false}>
                <Typography variant="subtitle1">Are you sure you want to delete the <b>{subscriberLabel}</b> subscriber?</Typography>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="error" type="submit">Delete</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default DeleteSubscriberDialog;